// defaultFilters — the initial/reset filter values for RestaurantSearch.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (the module-level
// `defaultFilters` object used as the `useState` initial value and on every
// reset) as part of the behavior-preserving refactor (issue #240). Same keys,
// same values (`cuisine: ''`, `priceRange: ''`, `minRating: 0`, `radius: 5`),
// same order as the source.
//
// The source always spread `{ ...defaultFilters }` at each use site (initial
// state, `clearFilters`, `handleClearSearch`) so no two filter states share a
// reference. `getDefaultFilters()` reproduces that by returning a FRESH copy on
// every call — mirroring how `manualTripCreator/logic/getEmptyForm.js` handled
// the equivalent `EMPTY_FORM`. The `defaultFilters` constant is also exported
// for callers that only need to read the canonical defaults.
//
// Totality: every default is a fixed literal, so no clock/RNG/input is read and
// the factory cannot throw.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * The canonical default filter values for the restaurant search.
 *
 * @type {{ cuisine: string, priceRange: string, minRating: number, radius: number }}
 */
export const defaultFilters = {
  cuisine: '',
  priceRange: '',
  minRating: 0,
  radius: 5
};

/**
 * Build a fresh copy of the default filter values.
 *
 * @returns {{ cuisine: string, priceRange: string, minRating: number, radius: number }}
 *          A new object with the default filter values (no shared reference).
 */
export function getDefaultFilters() {
  return { ...defaultFilters };
}

export default defaultFilters;
